import React, { useState } from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { useCountdown } from '../hooks/useCountdown';
import { CheckCircle2, AlertTriangle, Plus, Minus } from 'lucide-react';
import { PRODUCTS } from './MetaPixel';
export const ProductTomos = () => {
  const [openTomo, setOpenTomo] = useState<number | null>(null);
  const tomos = [{
    emoji: '📙',
    title: 'Tomo 1 — El Despertar Digital',
    sessions: 'Mentalidad y ecosistema de MeLi',
    months: 'Fundamentos · Algoritmo · Modelos de negocio',
    desc: 'Entendé cómo piensa MeLi antes de publicar.',
    color: 'bg-[#FF6B00]',
    borderColor: 'border-t-[#FF6B00]'
  }, {
    emoji: '📘',
    title: 'Tomo 2 — El Escudo Fiscal',
    sessions: 'AFIP, IIBB, Monotributo y retenciones',
    months: 'Impuestos · Retenciones · Contador digital',
    desc: 'Pagá exactamente lo que corresponde. Ni un peso más.',
    color: 'bg-[#3B82F6]',
    borderColor: 'border-t-[#3B82F6]'
  }, {
    emoji: '📕',
    title: 'Tomo 3 — Radar de Rentabilidad',
    sessions: 'Encontrá los productos que dejan ganancia',
    months: 'Nichos · Márgenes · Investigación de mercado',
    desc: 'Elegí bien antes de invertir en stock.',
    color: 'bg-[#EF4444]',
    borderColor: 'border-t-[#EF4444]'
  }, {
    emoji: '📓',
    title: 'Tomo 4 — La Fábrica de Clicks',
    sessions: 'Publicaciones que dominan el algoritmo',
    months: 'Títulos SEO · Fotos · Descripciones · Fichas técnicas',
    desc: 'Aparecer primero no es suerte. Es sistema.',
    color: 'bg-[#8B5CF6]',
    borderColor: 'border-t-[#8B5CF6]'
  }, {
    emoji: '📗',
    title: 'Tomo 5 — La Máquina Operativa',
    sessions: 'Operación diaria sin caos',
    months: 'Full · Flex · Stock · Atención · Reputación',
    desc: 'El negocio que opera bien vende más sin trabajar más.',
    color: 'bg-[#10B981]',
    borderColor: 'border-t-[#10B981]'
  }, {
    emoji: '📔',
    title: 'Tomo 6 — El Salto del Dueño',
    sessions: 'De vendedor a empresario digital',
    months: 'Escala · Equipo · Automatización · Crecimiento',
    desc: 'Dejá de operar el negocio. Empezá a dirigirlo.',
    color: 'bg-[#F59E0B]',
    borderColor: 'border-t-[#F59E0B]'
  }];
  const features = ['Algoritmo de MeLi explicado y aplicado', 'Sistema fiscal y retenciones ordenado', 'Publicaciones que aparecen primero', 'Full y Flex implementados correctamente', 'Calculadora de ganancia real incluida', 'Prompts de IA para todo el negocio'];
  const featureChips = ['✅ Algoritmo de MeLi explicado y aplicado', '✅ Sistema fiscal y retenciones ordenado', '✅ Publicaciones que aparecen primero', '✅ Full y Flex implementados correctamente', '✅ Calculadora de ganancia real incluida', '✅ Prompts de IA para todo el negocio'];
  return <Section className="bg-bg-base !pt-3 md:!pt-8" data-id="element-18">
      <FadeIn className="text-center mb-8 md:mb-12" data-id="element-19">
        {/* Yellow trust pill */}
        <div className="flex justify-center mb-4 md:mb-5" data-id="element-20">
          <span className="inline-flex items-center gap-1.5 font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[11px] px-3 py-1 md:px-3.5 md:py-1.5 rounded-full border border-brandYellow/30" style={{
          background: '#1B2236',
          color: '#FFE600',
          boxShadow: '0 2px 8px rgba(255,230,0,0.1)'
        }} data-id="element-21">
            🏆 Sistema N°1 para comerciantes que venden en Mercado Libre
            Argentina
          </span>
        </div>

        <h2 className="font-display font-extrabold uppercase text-txt-primary mb-3 md:mb-4 md:text-[44px] text-[32px]" data-id="element-22">
          MEGAPACK COMERCIO PRODUCTIVO{' '}
          <span className="text-brandGold" data-id="element-23">2026™</span>
        </h2>
        <p className="font-sans text-[14px] md:text-[16px] leading-[1.5] md:leading-[1.7] text-txt-body" data-id="element-24">
          6 Tomos + 6 Bonos — Sistema completo para vender, rankear y escalar en
          MeLi Argentina
        </p>
      </FadeIn>

      {/* Colored book strip with emoji */}
      <FadeIn delay={0.2} className="mb-5 md:mb-8" data-id="element-25">
        <div className="flex justify-center gap-2 md:gap-4 px-2 md:px-0" data-id="element-26">
          {tomos.map((tomo, i) => <div key={i} className={`${tomo.color} w-[44px] md:w-28 h-[60px] md:h-36 rounded-md md:rounded-lg shadow-lg flex flex-col items-center justify-center gap-0.5 md:gap-2 p-1 md:p-3 text-center text-white relative overflow-hidden transform hover:-translate-y-1 transition-transform border border-white/20`} data-id="element-27">
              <div className="absolute inset-0 bg-gradient-to-b from-white/10 to-transparent h-1/3" data-id="element-28"></div>
              <span className="font-sans font-bold uppercase tracking-[1px] text-[8px] md:text-[10px] leading-tight drop-shadow-md relative z-10 text-white" data-id="element-29">
                Tomo {i + 1}
              </span>
            </div>)}
        </div>
        <div className="text-center mt-3 md:mt-4" data-id="element-30">
          <span className="inline-block bg-brandYellow text-brandNavy font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[11px] px-3 py-1 md:px-4 md:py-1.5 rounded-full shadow-sm" data-id="element-31">
            6 TOMOS COMPLETOS
          </span>
        </div>
      </FadeIn>

      <FadeIn delay={0.3} className="mb-8 md:mb-12" data-id="element-32">
        <div className="flex flex-wrap justify-center gap-x-1 gap-y-1 md:gap-x-1.5 md:gap-y-1.5 max-w-3xl mx-auto" data-id="element-33">
          {featureChips.map((chip, i) => <span key={i} className="bg-brandYellow/10 text-brandYellow border border-brandYellow/30 px-1.5 py-0.5 md:px-2 md:py-1 rounded-full font-sans font-bold uppercase tracking-[0.5px] md:tracking-[1px] text-[8.5px] md:text-[10px] whitespace-nowrap" data-id="element-34">
              {chip}
            </span>)}
        </div>
      </FadeIn>

      <FadeIn delay={0.35} className="text-center mb-5 md:mb-7" data-id="element-35">
        <div className="inline-flex items-center gap-2 bg-bg-card border border-brandYellow/50 rounded-full px-4 py-1.5 md:px-5 md:py-2" data-id="element-36">
          <span className="font-sans font-bold uppercase tracking-[1.5px] text-[11px] md:text-[13px] text-brandYellow" data-id="element-37">
            📦 Lo que recibís:
          </span>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-5 mb-12 md:mb-16" data-id="element-38">
        {tomos.map((tomo, i) => {
        const isOpen = openTomo === i;
        return <FadeIn key={i} delay={Math.min(i * 0.05, 0.2)} data-id="element-39">
              <button type="button" onClick={() => setOpenTomo(isOpen ? null : i)} className={`w-full text-left bg-bg-card rounded-[16px] md:rounded-[20px] p-3 md:p-6 border-y border-r transition-all border-l-[4px] ${isOpen ? 'border-brandYellow shadow-[0_0_15px_rgba(255,230,0,0.1)]' : `border-y-line border-r-line border-l-brandYellow`}`} aria-expanded={isOpen} data-id="element-40">
                <div className="flex items-start justify-between gap-3" data-id="element-41">
                  <div className="flex items-start gap-2.5 md:gap-3 min-w-0 flex-1" data-id="element-42">
                    <div className="text-xl md:text-4xl shrink-0" data-id="element-43">
                      {tomo.emoji}
                    </div>
                    <div className="min-w-0" data-id="element-44">
                      <h3 className="font-sans font-bold text-[14px] md:text-xl text-txt-primary leading-snug mb-1.5 md:mb-2" data-id="element-45">
                        {tomo.title}
                      </h3>
                      <div className="flex flex-wrap gap-1.5" data-id="element-46">
                        <span className="font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[11px] text-brandYellow bg-brandYellow/10 px-2 py-0.5 rounded" data-id="element-47">
                          {tomo.sessions}
                        </span>
                        <span className="font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[11px] text-txt-muted bg-bg-highlight px-2 py-0.5 rounded" data-id="element-48">
                          {tomo.months}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className={`w-7 h-7 md:w-8 md:h-8 rounded-full flex items-center justify-center shrink-0 transition-all ${isOpen ? 'bg-brandYellow text-brandNavy rotate-180' : 'bg-bg-highlight text-txt-primary hover:bg-line'}`} data-id="element-49">
                    {isOpen ? <Minus size={14} data-id="element-50" /> : <Plus size={14} data-id="element-51" />}
                  </div>
                </div>
                <div className={`grid transition-all duration-300 ease-out ${isOpen ? 'grid-rows-[1fr] opacity-100 mt-3 md:mt-4' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-52">
                  <div className="overflow-hidden" data-id="element-53">
                    <p className="font-sans font-bold text-[13px] md:text-[16px] leading-[1.6] text-txt-body mb-2" data-id="element-54">
                      "{tomo.desc}"
                    </p>
                    <p className="font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[11px] text-brandGold" data-id="element-55">
                      Contenido de alto valor · Listo para aplicar desde hoy
                    </p>
                  </div>
                </div>
              </button>
            </FadeIn>;
      })}
      </div>

      <FadeIn delay={0.4} data-id="element-56">
        <div className="bg-bg-card rounded-[20px] p-5 md:p-10 border border-line max-w-4xl mx-auto" data-id="element-57">
          <h3 className="font-sans font-bold text-lg md:text-xl text-center text-txt-primary leading-snug mb-5 md:mb-8" data-id="element-58">
            Leés el programa, seguís el paso a paso y aplicás.
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-2.5 md:gap-4" data-id="element-59">
            {features.map((feature, i) => <div key={i} className="flex items-start gap-2 md:gap-3" data-id="element-60">
                <CheckCircle2 className="text-success shrink-0 mt-0.5 w-4 h-4 md:w-5 md:h-5" data-id="element-61" />
                <span className="font-sans text-[14px] md:text-[16px] leading-[1.6] text-txt-body" data-id="element-62">
                  {feature}
                </span>
              </div>)}
          </div>

          <div className="mt-6 md:mt-8 text-center" data-id="element-63">
            <p className="font-sans font-bold text-base md:text-xl text-brandGold leading-snug" data-id="element-64">
              Sin experiencia previa. Sin información confusa. Un sistema simple
              para pasar de cero a tus primeras ventas en Mercado Libre.
            </p>
          </div>
        </div>
      </FadeIn>
    </Section>;
};
export const Bonuses = () => {
  const bonuses = [{
    num: '01',
    icon: '🚀',
    title: 'Setup Express Mercado Libre 2026',
    desc: 'Configurá tu cuenta como profesional desde el día 1. Cada paso sin errores.',
    value: '$15.000'
  }, {
    num: '02',
    icon: '🏪',
    title: 'Puente al Digital',
    desc: 'Guía para comerciantes físicos que nunca vendieron online. Tu negocio del local a MeLi.',
    value: '$12.000'
  }, {
    num: '03',
    icon: '💬',
    title: 'Pack de Respuestas y Publicaciones Pro',
    desc: 'Plantillas listas para responder preguntas, manejar reclamos y comunicar como profesional.',
    value: '$10.000'
  }, {
    num: '04',
    icon: '🧮',
    title: 'Calculadora de Ganancia Real',
    desc: 'Calculá el precio correcto de cada producto antes de publicar. Nunca más márgenes sorpresa.',
    value: '$12.000'
  }, {
    num: '05',
    icon: '🤖',
    title: 'Prompt Bank IA Para Vendedores de MeLi',
    desc: '+50 prompts listos para investigar, publicar, atender y crecer usando inteligencia artificial.',
    value: '$15.000'
  }, {
    num: '06',
    icon: '📅',
    title: 'Desafío 30 Días Para Activar tu Negocio',
    desc: 'Plan diario con tarea concreta por día. De cero a primera venta en 30 días.',
    value: '$10.000'
  }];
  return <Section className="bg-bg-alt" data-id="element-65">
      <FadeIn className="text-center mb-8 md:mb-14" data-id="element-66">
        <h2 className="font-display font-extrabold uppercase md:text-[44px] text-txt-primary mb-2 md:mb-4 text-[34px]" data-id="element-67">
          + 6 BONOS <span className="text-brandGold" data-id="element-68">ESTRATÉGICOS</span>
        </h2>
        <p className="font-sans text-[14px] md:text-[16px] leading-[1.5] md:leading-[1.7] text-txt-body" data-id="element-69">
          Incluidos en todas las ofertas — sin costo extra
        </p>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-2.5 md:gap-4 mb-8 md:mb-12" data-id="element-70">
        {bonuses.map((bono, i) => <FadeIn key={i} delay={Math.min(i * 0.05, 0.2)} data-id="element-71">
            <div className="bg-bg-card rounded-[12px] p-2.5 md:p-4 border border-line border-l-[4px] border-l-brandYellow h-full relative overflow-hidden flex flex-col" data-id="element-72">
              <div className="absolute -right-1 -top-2 text-[36px] md:text-[64px] font-display font-black text-white/5 leading-none" data-id="element-73">
                {bono.num}
              </div>
              <div className="flex items-center justify-between gap-2 mb-1.5" data-id="element-74">
                <div className="flex items-center gap-1.5" data-id="element-75">
                  <span className="text-lg md:text-xl" data-id="element-76">🎁</span>
                  <div className="font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[10px] text-brandYellow" data-id="element-77">
                    BONO {bono.num}
                  </div>
                </div>
                <span className="text-lg md:text-xl" data-id="element-78">{bono.icon}</span>
              </div>
              <h3 className="font-sans font-bold text-[12.5px] md:text-[15px] text-txt-primary leading-snug mb-1 md:mb-1.5" data-id="element-79">
                {bono.title}
              </h3>
              <p className="font-sans text-[11.5px] md:text-[13.5px] leading-[1.45] md:leading-[1.55] text-txt-body mb-2.5 md:mb-3" data-id="element-80">
                {bono.desc}
              </p>
              <div className="mt-auto pt-2 md:pt-2.5 border-t border-line flex items-center justify-between gap-2" data-id="element-81">
                <span className="font-sans font-normal text-[12px] md:text-[14px] line-through text-danger" data-id="element-82">
                  {bono.value}
                </span>
                <span className="bg-success text-white font-sans font-bold uppercase tracking-[1px] text-[8.5px] md:text-[10px] px-2 py-0.5 rounded-full" data-id="element-83">
                  GRATIS
                </span>
              </div>
            </div>
          </FadeIn>)}
      </div>

      <FadeIn delay={0.4} className="text-center bg-bg-card p-5 md:p-8 rounded-[20px] border border-line max-w-2xl mx-auto" data-id="element-84">
        <p className="font-sans text-[14px] md:text-[16px] leading-[1.6] text-txt-body mb-2" data-id="element-85">
          Valor total de los 6 Bonos
        </p>
        <p className="font-sans font-normal text-[16px] md:text-[18px] line-through text-danger mb-2" data-id="element-86">
          $74.000
        </p>
        <p className="font-display font-black text-[24px] md:text-[44px] leading-[1.1] mb-1 md:mb-2 text-[#22C55E]" data-id="element-87">
          🎁 GRATIS — Solo con tu MEGAPACK
        </p>
        <p className="font-sans text-[13px] md:text-[16px] leading-[1.5] text-txt-muted" data-id="element-88">
          Incluidos en todas las ofertas. Siempre.
        </p>
      </FadeIn>
    </Section>;
};
export const UrgencyCounter = () => {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <section className="bg-bg-base px-4 md:px-6 py-10 md:py-20 overflow-hidden" data-id="element-89">
      <div className="max-w-[1100px] mx-auto" data-id="element-90">
        <FadeIn className="max-w-3xl mx-auto" data-id="element-91">
          <div className="rounded-[20px] border-2 border-brandYellow p-6 md:p-10 text-center space-y-6 bg-bg-card max-w-lg mx-auto shadow-[0_0_20px_rgba(255,230,0,0.1)]" data-id="element-92">
            <h3 className="font-sans font-bold uppercase tracking-[1.5px] text-[11px] text-brandYellow" data-id="element-93">
              ⏰ OFERTA DE LANZAMIENTO — CIERRA EN:
            </h3>
            <div className="flex justify-center gap-2.5 md:gap-4 text-white" data-id="element-94">
              <div className="bg-bg-highlight border border-line rounded-[14px] w-[72px] h-[80px] md:w-[90px] md:h-[96px] flex flex-col items-center justify-center" data-id="element-95">
                <div className="font-display font-black text-[40px] md:text-[52px] text-brandYellow leading-none" data-id="element-96">
                  {hours.toString().padStart(2, '0')}
                </div>
                <div className="font-sans font-bold uppercase tracking-[1.5px] text-[9px] md:text-[11px] text-brandYellow mt-1" data-id="element-97">
                  hs
                </div>
              </div>
              <div className="font-display font-black text-[40px] md:text-[52px] py-2 text-txt-primary flex items-center" data-id="element-98">
                :
              </div>
              <div className="bg-bg-highlight border border-line rounded-[14px] w-[72px] h-[80px] md:w-[90px] md:h-[96px] flex flex-col items-center justify-center" data-id="element-99">
                <div className="font-display font-black text-[40px] md:text-[52px] text-brandYellow leading-none" data-id="element-100">
                  {minutes.toString().padStart(2, '0')}
                </div>
                <div className="font-sans font-bold uppercase tracking-[1.5px] text-[9px] md:text-[11px] text-brandYellow mt-1" data-id="element-101">
                  min
                </div>
              </div>
              <div className="font-display font-black text-[40px] md:text-[52px] py-2 text-txt-primary flex items-center" data-id="element-102">
                :
              </div>
              <div className="bg-bg-highlight border border-line rounded-[14px] w-[72px] h-[80px] md:w-[90px] md:h-[96px] flex flex-col items-center justify-center" data-id="element-103">
                <div className="font-display font-black text-[40px] md:text-[52px] text-brandYellow leading-none" data-id="element-104">
                  {seconds.toString().padStart(2, '0')}
                </div>
                <div className="font-sans font-bold uppercase tracking-[1.5px] text-[9px] md:text-[11px] text-brandYellow mt-1" data-id="element-105">
                  seg
                </div>
              </div>
            </div>

            <div className="flex items-center justify-center gap-2 font-sans font-bold text-base md:text-xl text-txt-primary leading-snug" data-id="element-106">
              <AlertTriangle size={20} className="text-brandGold" data-id="element-107" />
              <span data-id="element-108">Después vuelve a su precio original. No vuelve.</span>
            </div>

            <div className="p-4 rounded-[14px] border border-line bg-bg-alt" data-id="element-109">
              <div className="flex justify-between font-sans text-[13px] md:text-[15px] leading-[1.5] text-txt-body mb-3" data-id="element-110">
                <span className="flex items-center gap-2" data-id="element-111">
                  <span className="w-2 h-2 rounded-full bg-brandYellow animate-pulse" data-id="element-112"></span>{' '}
                  Cupos al precio de lanzamiento
                </span>
                <span className="text-brandYellow font-bold" data-id="element-113">Quedan pocos</span>
              </div>
              <div className="w-full bg-line rounded-full h-2 mb-2 overflow-hidden" data-id="element-114">
                <div className="bg-brandYellow h-full rounded-full" style={{
                width: '71%'
              }} data-id="element-115"></div>
              </div>
              <p className="font-sans text-[12px] md:text-[13px] text-txt-muted text-right" data-id="element-116">
                71% de los cupos ya tomados
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};
export const Pricing = () => {
  const [selected, setSelected] = useState<'plus' | 'basic'>('plus');
  const checkoutUrl = PRODUCTS[selected].checkoutUrl;
  const ctaText = selected === 'plus' ? 'SÍ, QUIERO EL SISTEMA COMPLETO' : 'QUIERO EL MEGAPACK';
  return <Section className="bg-bg-alt" id="pricing" data-id="element-117">
      <FadeIn className="text-center mb-8 md:mb-12" data-id="element-118">
        <h2 className="font-display font-extrabold uppercase md:text-[44px] text-txt-primary text-[40px]" data-id="element-119">
          Elegí tu <span className="text-brandGold" data-id="element-120">MEGAPACK:</span>
        </h2>
        <p className="font-sans text-[14px] md:text-[16px] leading-[1.5] text-txt-body mt-2" data-id="element-121">
          Todas las opciones incluyen los 6 bonos estratégicos
        </p>
      </FadeIn>

      <div className="max-w-2xl mx-auto space-y-4 md:space-y-5" data-id="element-122">
        {/* Option Plus - MÁS ELEGIDO (first) */}
        <FadeIn delay={0.1} data-id="element-123">
          <button onClick={() => setSelected('plus')} className={`w-full text-left rounded-[16px] md:rounded-[20px] p-3.5 md:p-6 transition-all duration-300 border-2 bg-bg-card relative ${selected === 'plus' ? 'border-brandYellow shadow-[0_0_15px_rgba(255,230,0,0.1)]' : 'border-line hover:border-brandGold'}`} data-id="element-124">
            {selected === 'plus' && <div className="absolute -top-2.5 left-1/2 transform -translate-x-1/2 text-brandNavy font-sans font-bold uppercase tracking-[1.5px] text-[9px] md:text-[11px] px-2.5 md:px-3.5 py-0.5 md:py-1 rounded-full whitespace-nowrap bg-brandYellow" data-id="element-125">
                ⭐ MÁS ELEGIDO
              </div>}
            <div className="flex items-start gap-2.5 md:gap-4" data-id="element-126">
              <div className={`w-4 h-4 md:w-6 md:h-6 rounded-full border-2 mt-0.5 md:mt-1 shrink-0 flex items-center justify-center ${selected === 'plus' ? 'border-brandYellow' : 'border-line'}`} data-id="element-127">
                {selected === 'plus' && <div className="w-2 h-2 md:w-3 md:h-3 rounded-full bg-brandYellow" data-id="element-128"></div>}
              </div>
              <div className="flex-grow min-w-0" data-id="element-129">
                <div className="flex flex-wrap items-center gap-1.5 md:gap-2 mb-1.5 md:mb-2" data-id="element-130">
                  <span className="text-base md:text-xl" data-id="element-131">🏆</span>
                  <h3 className="font-sans font-bold text-[13px] md:text-xl text-txt-primary leading-snug" data-id="element-132">
                    MEGAPACK +{' '}
                    <span className={`transition-colors ${selected === 'plus' ? 'text-brandGold' : 'text-txt-primary'}`} data-id="element-133">
                      POTENCIADORES
                    </span>
                  </h3>
                </div>
                <div className="flex flex-wrap gap-2 mb-1.5 md:mb-3" data-id="element-134">
                  <span className="bg-success/90 text-white font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[11px] px-2 md:px-2.5 py-0.5 md:py-1 rounded-full" data-id="element-135">
                    AHORRÁS $15.000 🔥
                  </span>
                </div>
                <p className="font-sans text-[11.5px] md:text-[15px] leading-[1.4] md:leading-[1.5] text-txt-body" data-id="element-136">
                  6 Tomos + 6 Bonos +{' '}
                  <span className={`font-bold transition-colors ${selected === 'plus' ? 'text-brandGold' : 'text-txt-body'}`} data-id="element-137">
                    ✨ 6 Volúmenes Potenciadores
                  </span>
                </p>
              </div>
              <div className="text-right shrink-0" data-id="element-138">
                <p className="font-sans font-normal text-[12px] md:text-[18px] line-through text-danger" data-id="element-139">
                  $57.990
                </p>
                <p className={`font-display font-black text-[24px] md:text-[52px] leading-none ${selected === 'plus' ? 'text-brandYellow' : 'text-txt-primary'}`} data-id="element-140">
                  $34.990
                </p>
              </div>
            </div>
          </button>
        </FadeIn>

        {/* Option Basic */}
        <FadeIn delay={0.2} data-id="element-141">
          <button onClick={() => setSelected('basic')} className={`w-full text-left rounded-[16px] md:rounded-[20px] p-3.5 md:p-6 transition-all duration-300 border-2 bg-bg-card ${selected === 'basic' ? 'border-brandYellow shadow-[0_0_15px_rgba(255,230,0,0.1)]' : 'border-line hover:border-brandGold'}`} data-id="element-142">
            <div className="flex items-start gap-2.5 md:gap-4" data-id="element-143">
              <div className={`w-4 h-4 md:w-6 md:h-6 rounded-full border-2 mt-0.5 md:mt-1 shrink-0 flex items-center justify-center ${selected === 'basic' ? 'border-brandYellow' : 'border-line'}`} data-id="element-144">
                {selected === 'basic' && <div className="w-2 h-2 md:w-3 md:h-3 rounded-full bg-brandYellow" data-id="element-145"></div>}
              </div>
              <div className="flex-grow min-w-0" data-id="element-146">
                <div className="flex flex-wrap items-center gap-1.5 md:gap-2 mb-1.5 md:mb-2" data-id="element-147">
                  <span className="text-base md:text-xl" data-id="element-148">📘</span>
                  <h3 className="font-sans font-bold text-[13px] md:text-xl text-txt-primary leading-snug" data-id="element-149">
                    MEGAPACK{' '}
                    <span className={`transition-colors ${selected === 'basic' ? 'text-brandGold' : 'text-txt-primary'}`} data-id="element-150">
                      COMERCIO PRODUCTIVO 2026
                    </span>
                  </h3>
                </div>
                <p className="font-sans text-[11.5px] md:text-[15px] leading-[1.4] md:leading-[1.5] text-txt-body" data-id="element-151">
                  6 Tomos Completos + 6 Bonos incluidos
                </p>
              </div>
              <div className="text-right shrink-0" data-id="element-152">
                <p className="font-sans font-normal text-[12px] md:text-[18px] line-through text-danger" data-id="element-153">
                  $39.990
                </p>
                <p className={`font-display font-black text-[24px] md:text-[52px] leading-none ${selected === 'basic' ? 'text-brandYellow' : 'text-txt-primary'}`} data-id="element-154">
                  $22.990
                </p>
              </div>
            </div>
          </button>
        </FadeIn>

        {/* Single CTA */}
        <FadeIn delay={0.3} data-id="element-155">
          <div className="pt-2 md:pt-4" data-id="element-156">
            <div className="text-center mb-2.5 md:mb-3" data-id="element-157">
              <p className="font-sans font-bold text-[12px] md:text-[14px] text-txt-primary leading-snug" data-id="element-158">
                👇 Tu primer venta profesional en MeLi empieza acá
              </p>
              <p className="font-sans text-[10.5px] md:text-[12px] text-brandGold uppercase tracking-[1.5px] font-bold mt-1 animate-pulse" data-id="element-159">
                ⚡ Precio de lanzamiento — por tiempo limitado
              </p>
            </div>
            <CTAButton href={checkoutUrl} fullWidth trackingProduct={selected} data-id="element-160">
              {ctaText}
            </CTAButton>
            <div className="flex flex-wrap justify-center gap-3 md:gap-4 mt-3 md:mt-4 font-sans text-[11px] md:text-[13px] text-txt-muted" data-id="element-161">
              <span data-id="element-162">🔒 Pago 100% seguro</span>
              <span data-id="element-163">⚡ Acceso en 5 minutos</span>
              <span data-id="element-164">🛡️ Garantía 15 días</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </Section>;
};
export const Potenciador = () => {
  const comparisons = [{
    bad: 'Publicaciones en la página 3',
    good: 'Publicaciones en el top 3 del buscador'
  }, {
    bad: 'Publicidad que gasta sin retorno',
    good: 'Campañas con RETORNO 5x validado'
  }, {
    bad: 'Retenciones de IIBB perdidas',
    good: 'Retenciones computadas como crédito fiscal'
  }, {
    bad: 'Despacho manual que consume 4 horas diarias',
    good: 'Full operando: 10 minutos diarios de logística'
  }, {
    bad: 'Vendés un producto por transacción',
    good: 'Combos que duplican el ticket promedio'
  }, {
    bad: 'Negocio que depende de que estés presente',
    good: 'Sistema automático que vende mientras dormís'
  }];
  const volumes = [{
    icon: '🔍',
    title: 'Vender Primero',
    sub: 'Dominá el Buscador',
    desc: 'Aparecer #1 en MeLi sin bajar el precio. SEO avanzado, títulos que rankean y el algoritmo de tu lado.',
    chapters: '6 capítulos · Sistema completo'
  }, {
    icon: '📢',
    title: 'Publicidad Rentable',
    sub: 'Gastá Menos, Vendé Más',
    desc: 'Mercado Ads con ROAS 5x desde el día 1. Meta Ads y Google Ads para traer tráfico a MeLi.',
    chapters: '8 capítulos · Campañas listas'
  }, {
    icon: '📦',
    title: 'Envíos Rápidos',
    sub: 'El Secreto de Full y Flex',
    desc: 'Activar Full correctamente para vender más, rankear mejor y eliminar el trabajo de despacho.',
    chapters: '8 capítulos · Implementación total'
  }, {
    icon: '🧾',
    title: 'Impuestos Inteligentes',
    sub: 'Protegé tu Plata',
    desc: 'AFIP, IIBB, Monotributo y Convenio Multilateral. Pagá lo justo y recuperá las retenciones.',
    chapters: '8 capítulos · Estrategia fiscal'
  }, {
    icon: '🎁',
    title: 'Combos Explosivos',
    sub: 'Subí tu Ticket de Venta',
    desc: 'Vender 2 o 3 productos en lugar de 1. Kits, upselling y cross-selling que funcionan en MeLi.',
    chapters: '8 capítulos · Más ganancia por venta'
  }, {
    icon: '🤖',
    title: 'Negocio Automático',
    sub: 'Vendé Mientras Dormís',
    desc: 'IA y automatización para que tu tienda de MeLi funcione sola. Full + IA + Panel de control.',
    chapters: '8 capítulos · Piloto automático'
  }];
  return <Section className="bg-bg-base" data-id="element-165">
      <FadeIn className="text-center max-w-3xl mx-auto mb-10 md:mb-16" data-id="element-166">
        <h2 className="font-display font-extrabold uppercase text-[28px] md:text-[44px] leading-[1.1] text-txt-primary mb-4 md:mb-6" data-id="element-167">
          🚀 ¿QUÉ AGREGAN LOS{' '}
          <span className="text-brandGold" data-id="element-168">POTENCIADORES?</span>
        </h2>
        <p className="font-sans text-[14px] md:text-[16px] leading-[1.5] md:leading-[1.7] text-txt-body" data-id="element-169">
          El MEGAPACK resuelve el problema base. Los Potenciadores te dan{' '}
          <strong className="text-txt-primary" data-id="element-170">
            dominio total en las 6 áreas más rentables del ecommerce argentino.
          </strong>
        </p>
      </FadeIn>

      <FadeIn delay={0.2} className="max-w-6xl mx-auto mb-12 md:mb-16" data-id="element-171">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4 mb-8 md:mb-10" data-id="element-172">
          {volumes.map((vol, i) => <div key={i} className="bg-bg-card border border-line rounded-[14px] md:rounded-[16px] p-3 md:p-5 hover:border-brandYellow transition-all flex flex-col" data-id="element-173">
              <div className="flex items-center gap-2 md:gap-3 mb-2 md:mb-3" data-id="element-174">
                <div className="text-xl md:text-3xl shrink-0" data-id="element-175">{vol.icon}</div>
                <div className="min-w-0" data-id="element-176">
                  <h4 className="font-display font-black uppercase text-[15px] md:text-[22px] leading-[1.1] text-txt-primary mb-0.5" data-id="element-177">
                    {vol.title}
                  </h4>
                  <p className="font-sans font-bold uppercase tracking-[0.5px] md:tracking-[1px] text-[8.5px] md:text-[11px] text-brandGold" data-id="element-178">
                    {vol.sub}
                  </p>
                </div>
              </div>
              <p className="font-sans text-[11.5px] md:text-[15px] leading-[1.45] md:leading-[1.6] text-txt-body mb-2.5 md:mb-4 flex-grow" data-id="element-179">
                {vol.desc}
              </p>
              <div className="bg-bg-highlight text-txt-body font-sans font-bold uppercase tracking-[0.5px] md:tracking-[1px] text-[8.5px] md:text-[11px] inline-block px-2 md:px-2.5 py-0.5 md:py-1 rounded-md self-start" data-id="element-180">
                {vol.chapters}
              </div>
            </div>)}
        </div>

        <div className="bg-bg-card border-2 border-brandYellow rounded-[20px] p-5 md:p-8 text-center max-w-3xl mx-auto" data-id="element-181">
          <p className="font-display font-black uppercase text-[22px] md:text-[40px] leading-[1.15] text-txt-primary mb-1 md:mb-2" data-id="element-182">
            Dominio total en las 6 áreas más rentables del ecommerce argentino
          </p>
        </div>
      </FadeIn>

      <div className="max-w-4xl mx-auto" data-id="element-183">
        <div className="bg-bg-card rounded-[20px] overflow-hidden border border-line" data-id="element-184">
          <div className="grid grid-cols-2 bg-bg-highlight p-3 md:p-5 text-center" data-id="element-185">
            <div className="font-sans font-bold text-[13px] md:text-[16px] text-txt-muted" data-id="element-186">
              ❌ Sin Potenciadores
            </div>
            <div className="font-sans font-bold text-[13px] md:text-[16px] text-success" data-id="element-187">
              ✅ Con Potenciadores
            </div>
          </div>
          <div className="divide-y divide-line" data-id="element-188">
            {comparisons.map((row, i) => <div key={i} className="grid grid-cols-2 p-3 md:p-5 gap-3 md:gap-5" data-id="element-189">
                <div className="font-sans text-[12px] md:text-[16px] leading-[1.5] md:leading-[1.7] text-txt-muted pr-2 md:pr-4" data-id="element-190">
                  {row.bad}
                </div>
                <div className="font-sans text-[12px] md:text-[16px] leading-[1.5] md:leading-[1.7] text-txt-primary pl-2 md:pl-4 border-l border-line" data-id="element-191">
                  {row.good}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </Section>;
};